module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "personal-center-form__section"
  }, [_c('h1', {
    staticClass: "personal-center-form__title repayment_h1"
  }, [_vm._v("还款计划详情"), _c('span', {
    staticClass: "ask-time"
  }, [_vm._v("申请时间　" + _vm._s(_vm.detail.applyDate))])]), _vm._v(" "), _c('div', {
    staticClass: "repayment-top"
  }, [_c('dl', {
    staticClass: "text-center should-repaymen"
  }, [_c('dt', [_vm._v("应还金额")]), _vm._v(" "), _c('dd', [_vm._v("¥" + _vm._s(_vm._f("addThousandSign")(_vm.detail.repayMoneySum, 2)))])]), _vm._v(" "), _c('ul', {
    staticClass: "repay-details"
  }, [_c('li', [_c('span', [_vm._v("本金")]), _c('strong', [_vm._v("¥" + _vm._s(_vm._f("addThousandSign")(_vm.detail.principal, 2)))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("保理费")]), _c('strong', [_vm._v("¥" + _vm._s(_vm._f("addThousandSign")(_vm.detail.factoringMoney, 2)))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("财务服务费")]), _c('strong', [_vm._v("¥" + _vm._s(_vm._f("addThousandSign")(_vm.detail.factoringServiceMoney, 2)))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("本期应还总额")]), _c('strong', {
    staticStyle: {
      "color": "#EB662B"
    }
  }, [_vm._v("¥" + _vm._s(_vm._f("addThousandSign")(_vm.detail.repayMoneySum, 2)))])])])]), _vm._v(" "), _c('repayment-list', {
    attrs: {
      "infoList": _vm.detail
    },
    on: {
      "getRepayList": _vm.getData
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6663a4ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/RepaymentInfo_bl.vue
// module id = 1075
// module chunks = 1